<script setup>
import { onMounted, ref } from "vue";
import { useSertStore } from "@/stores/sertStore";

import { getListCovers } from "@/utils/services";
import { useValidation } from "@/utils/useValidataion";
import { useRequestsStore } from "@/stores/storeRequests";
import SertHeader from "@/components/blocks/SertHeader.vue";
import BaseBtnLookSert from '../ui/BaseBtnLookSert.vue';

import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Scrollbar } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const storeSert = useSertStore();
const storeRequests = useRequestsStore();

const value = defineModel();

const { validation } = useValidation(value);

const listCovers = ref({ results: [] });
const slider = ref(null);
const swiperInstance = ref(null);

const onSwiper = (swiper) => {
    swiperInstance.value = swiper;
};

const onSlideChange = () => {
    // Пересчитываем позиции после изменения ширины активного слайда
    setTimeout(() => {
        swiperInstance.value?.update();
    }, 50);
};

const nextSreen = async () => {
    storeSert.goToScreen(storeSert.screens.recipient);
    history.pushState(null, "", `#${storeSert.screens.recipient}`);
};

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.authUserData);
    history.pushState(null, "", `#${storeSert.screens.authUserData}`);
};

onMounted(async () => {
    listCovers.value = await getListCovers();

    const script = document.createElement("script");
    const scriptPath = "/libs/spotlight.bundle.js";
    script.src = scriptPath;
    slider.value.append(script);
});
</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="4">
                <template #title>Выберите дизайн</template>
                <template #text>Подберите фото, которое подойдет к настроению вашего подарка наилучшим образом.</template
                >
            </SertHeader>
            <div class="slider" ref="slider">
                <Swiper
                    class="slider__swiper spotlight-group"
                    :modules="[Navigation, Scrollbar]"
                    slides-per-view="auto"
                    :loop="true"
                    :watch-slides-progress="true"
                    :navigation="{
                        nextEl: '.slider__next',
                        prevEl: '.slider__prev',
                    }"
                    :scrollbar="{
                        el: '.slider__scrollbar',
                        draggable: true,
                    }"
                    :breakpoints="{
                        320: {
                            spaceBetween: 8,
                            loop: false,
                        },
                        769: {
                            spaceBetween: 16,
                        },
                    }"
                    @swiper="onSwiper"
                    @slideChangeTransitionEnd="onSlideChange"
                >
                    <SwiperSlide
                        class="slider__slide"
                        v-for="{ image, id } in listCovers"
                        :key="id"
                    >
                        <label class="radio" :style="{ backgroundImage: `url(${image})` }">
                            <input
                                type="radio"
                                :checked="storeSert.checkedItems.imagePath.id === id"
                                @change="
                                    storeSert.updateCheckedItem('imagePath', 'id', id),
                                        storeSert.updateCheckedItem('imagePath', 'title', image),
                                        validation('imagePath')
                                "
                                :value="image"
                                v-model="value"
                                class="radio__real-radio"
                            />
                            <span class="radio__custom-radio"></span>
                            <button class="radio__zoom spotlight" :data-src="image">
                                <svg width="32" height="32"><use href="#zoom"></use></svg>
                            </button>
                        </label>
                    </SwiperSlide>
                </Swiper>
                <div class="slider__scrollbar"></div>
                <div class="slider__controls">
                    <button class="slider__prev slider__btn">
                        <svg width="56" height="56"><use href="#arrow-left"></use></svg>
                    </button>
                    <button class="slider__next slider__btn">
                        <svg width="56" height="56"><use href="#arrow-right"></use></svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="constructor__btns-inner">
            <div class="constructor__btns">
                <button
                    class="btn --black"
                    @click="previousSreen"
                    v-if="!storeRequests.isAuthenticated"
                >
                    <span>Назад</span>
                </button>
                <button
                    :disabled="storeSert.isBtnDisabled(['imagePath'])"
                    class="btn --full"
                    @click="nextSreen"
                >
                    <span>Далее</span>
                </button>
                <BaseBtnLookSert />
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.slider__swiper {
    width: 100%;
    height: 330px;
    padding-bottom: 1.8rem;
    @media (max-width: vars.$m) {
        height: 250px;
    }
    @media (max-width: vars.$x480) {
        height: 180px;
    }
    @media (max-width: vars.$x425) {
        height: 130px;
    }
}

.slider__scrollbar {
    display: none;
    height: 0.8rem;
    border-radius: 0.8rem;
    background: var(--main-light-8);
    width: 100%;
    cursor: grab;
    @media (max-width: vars.$m) {
        display: block;
        width: 98%;
    }
}

:deep(.swiper-scrollbar-drag) {
    background: #fff;
    border-radius: 0.8rem;
    height: 0.8rem;
}

.slider {
    position: relative;
    @media (max-width: vars.$m) {
        margin-bottom: 3.2rem;
        padding-right: 2rem;
        margin-right: -3.5rem;
    }
}

.slider__slide {
    width: 23.67%;
    transition: width 0.3s ease;
    @media (max-width: vars.$m) {
        width: 60%;
    }
    &.swiper-slide-active {
        width: 49.45%;
        @media (max-width: vars.$m) {
            width: 60%;
        }
        .radio {
            height: 100%;
        }
    }
}

.slider__controls {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}

.slider__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition) ease-in;
    svg {
        width: 5.6rem;
        aspect-ratio: 1;
    }
    @media (hover: hover) {
        &:hover {
            opacity: 0.4;
        }
    }
    @media (max-width: vars.$m) {
        display: none;
    }
}

.radio {
    position: relative;
    display: block;
    width: 100%;
    height: 13rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    z-index: 1;
    @media (max-width: vars.$m) {
        height: 100%;
    }
}

.radio__real-radio {
    width: 0;
    height: 0;
    position: absolute;
    opacity: 0;
    z-index: -1;
}

.radio__custom-radio {
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--system-fill-light);
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    background: var(--main-light-8);
}

.radio__custom-radio::before {
    content: "";
    display: inline-block;
    width: 2.4rem;
    height: 2.4rem;
    background-image: url("@/assets/img/icons/check.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
    position: absolute;
    transform: scale(0);
    transition: 0.2s ease-in;
}

.radio__real-radio:checked + .radio__custom-radio::before {
    transform: scale(1);
}

.radio__zoom {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 1.2rem;
    @media (hover: hover) {
        &:hover {
            svg {
                opacity: 1;
            }
        }
    }
    svg {
        width: 3.2rem;
        aspect-ratio: 1;
        stroke: #fff;
        fill: transparent;
        opacity: 0.4;
        transition: opacity var(--transition) ease-in;
    }
}
</style>
